import i18n from '@/localization/i18n';
import Login from '@/views/Login.vue';
import Home from '@/views/Home.vue';
import { loader } from '@/mixins/loader';
import { v4 as uuidv4 } from 'uuid';
import store from '@/store';
import Axios from 'redaxios';

export default [
  {
    path: '/',
    redirect: () => `${i18n.locale}/home`
  },
  {
    path: '/foerderkompass',
    redirect: () => `${i18n.locale}/foerderkompass`
  },
  {
    path: '/standortsuche',
    redirect: () => `${i18n.locale}/standortsuche`
  },
  {
    path: '/wissen',
    redirect: () => `${i18n.locale}/wissen`
  },
  {
    path: '/de/RE-USE_Brachflaechenrecycling',
    redirect: '/de/wissen/09592d7a-8ed5-4d5a-bd2a-5e395218b08d'
  },
  {
    path: '/:lang/home',
    name: 'home',
    component: Home,
    props: true,
    meta: {
      title: 'ecoplus Standortkompass',
      slugTitle: false,
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/foerderkompass/:foerderId?',
    name: 'foerderkompass',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheFoerderkompass.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Förderungen',
      desciption: 'Interaktives Tool zum Finden von Förderungen für Unternehmen in Niederösterreich',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/kontakt',
    name: 'kontakt',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheKontakt.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Kontakt',
      description:
        'Kontaktaufnahme zwecks Standortsuche, Förderungen und Wissenswertem für Unternehmen in Niederösterreich',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/nutzungsbedingungen',
    name: 'nutzungsbedingungen',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheNutzungsbedingungen.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Nutzungsbedingungen',
      description: 'Nutzungsbedingungen für den Standortkompass von ecoplus',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/datenschutz',
    name: 'datenschutz',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheDatenschutz.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Datenschutz',
      desctiption: 'Datenschutzbestimmungen für den Standortkompass von ecoplus',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/glossar/:glossarId?',
    name: 'glossar',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheGlossar.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Glossar',
      description: 'Wichtige Begriffe rund um Standorte und Förderungen für Unternehmen in Niederösterreich',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/wissen',
    name: 'wissen',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheWissen.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Wissen',
      slugTitle: false,
      description: 'Wissenswertes für Unternehmen, die in Niederösterreich einen Unternehmensstandort suchen',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/wissen/:wissenId',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheWissenDetail.vue'),
    name: 'wissendetail',
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Wissen / Details',
      description: 'Wissenswertes für Unternehmen, die in Niederösterreich einen Unternehmensstandort suchen',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/admin',
    redirect: () => `/${i18n.locale}/admin/liste`
  },
  {
    path: '/:lang/admin',
    redirect: () => `${i18n.locale}/admin/liste`
  },
  {
    path: '/:lang/admin/liste',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Browse.vue'),
    name: 'browse',
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Objekte',
      description: 'Editierbare Liste der im Standortkompass angebotenen Gewerbeimmobilien',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/objekt/neu',
    redirect: () => `/:lang/admin/objekt/${uuidv4()}`
  },
  {
    path: '/:lang/admin/objekt/:objektId',
    name: 'admin-objekt',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Editor.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Objekteditor',
      description: 'Erstellung und Bearbeitung von Gewerbeimmobilien im Standortkompass',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/objekteditor/:objektId',
    name: 'edit-objekt',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/user/Editor.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Objekteditor',
      description: 'Erstellung und Bearbeitung von Gewerbeimmobilien-Angeboten',
      requiresAuth: false
    }
  },
  {
    path: '/:lang/admin/benutzer',
    name: 'admin-benutzer',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Benutzer.vue'),
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Benutzer',
      description: 'Benutzerverwaltung',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/karten',
    name: 'admin-karten',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Karten.vue'),
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Karten',
      description: 'Kartenverwaltung',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/glossar',
    name: 'admin-glossar',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Glossar.vue'),
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Glossar',
      description: 'Verwaltung der Glossar-Einträge',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/glossar/:id',
    name: 'glossar-edit',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/GlossarEdit.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Glossar - Edit',
      description: 'Verwaltung eines Glossar-Eintrags',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/foerdermatrix',
    name: 'admin-foerdermatrix',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Foerdermatrix.vue'),
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Fördermatrix',
      description: 'Verwaltung der Fördermatrix',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/foerdermatrix/:id',
    name: 'foerdermatrix-edit',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/FoerdermatrixEdit.vue'),
    props: true,
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Fördermatrix - Edit',
      description: 'Verwaltung eines Fördermatrix-Eintrags',
      requiresAuth: true
    }
  },

  {
    path: '/:lang/admin/statistik',
    name: 'admin-statistik',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Statistik.vue'),
    meta: {
      title: 'ecoplus Standortkompass ADMIN - Statistik',
      description: 'Administration der Statistiken zum Standortkompass und dessen Nutzung',
      requiresAuth: true
    }
  },
  {
    path: '/statistik/panel',
    name: 'statistik-panel',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Statistik.vue'),
    meta: {
      title: 'Statistik Panel',
      description: 'Statistiken zum Standortkompass und dessen Nutzung',
      requiresAuth: false
    }
  },
  {
    path: '/:lang/admin/urlmanagement',
    name: 'admin-urlmanagement',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/UrlManagement.vue'),
    meta: {
      title: 'ecoplus Standortkompass ADMIN - URL Management',
      description: 'Verwaltung der URL-Shortcuts und Meta Descriptions',
      requiresAuth: true
    }
  },

  {
    path: '/:lang/admin/kampagnen',
    name: 'admin-kampagnen',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Kampagnen.vue'),
    meta: {
      title: 'ecoplus Standortkompass - Kampagnen',
      description: 'Verwaltung der Kampagnen',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/admin/kampagnen/neu',
    redirect: () => `/:lang/admin/kampagnen/${uuidv4()}`
  },
  {
    path: '/:lang/admin/kampagnen/:id',
    name: 'kampagnen-edit',
    props: true,
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/KampagnenEdit.vue'),
    meta: {
      title: 'ecoplus Standortkompass - Kampagnen',
      description: 'Verwaltung eine Kampagne',
      requiresAuth: true
    }
  },
  {
    path: '/:lang/standortsuche',
    name: 'standortsuche',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheStandortsuche.vue'),
    meta: {
      title: 'ecoplus Standortkompass - Standortsuche',
      description: 'Interaktive Standortsuche für Unternehmen in Niederösterreich',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/meineimmobilien',
    name: 'meineimmobilien'
  },
  {
    path: '/:lang/standortsuche/:objektId',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheStandortsuche.vue'),
    name: 'detailansicht',
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Standortsuche',
      description: params => `Details zum Objekt ${params.objektId} im ecoplus Standortkompass`,
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/standortsammlung/:standortsammlungIds',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/TheStandortsuche.vue'),
    name: 'standortsammlung',
    props: true,
    meta: {
      title: 'ecoplus Standortkompass - Standortsuche',
      description: 'Sammlung geeigneter Standorte',
      requiresAuth: false // set to real boolean for header items
    }
  },
  {
    path: '/:lang/login',
    component: Login,
    name: 'login',
    meta: {
      title: 'ecoplus Standortkompass - Login',
      description: 'Login für erweiterte Funktionen im Standortkompass von ecoplus'
    }
  },
  {
    path: '/:lang/logout',
    name: 'logout',
    meta: {
      title: 'ecoplus Standortkompass',
      description: 'Logout vom Standortkompass'
    },
    component: {
      async beforeRouteEnter(to, from, next) {
        try {
          await Axios.get('/api/logout');
          store.dispatch('userdata', null);
          store.dispatch('contact', null);
          // @ts-ignore
          await loader.methods.reLoad(store._vm); // reload user-specific data (contact, objekte)
          const path = store.state.pathAfterLogin
            ? `/${i18n.locale}/login?next=${store.state.pathAfterLogin}`
            : `/${i18n.locale}/home`;
          store.dispatch('pathAfterLogin', null);
          next(path);
        } catch (e) {
          next(`/${i18n.locale}/admin/liste`);
        }
      }
    }
  }
];
